

class MenuController {
  /* @ngInject */
  constructor(StorageService) {
    const that = this;
    that.isSuperAdmin = StorageService.getLocalStorage('superAdmin') === 'true'
  }
}

export default MenuController;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/menu.controller.js
 **/